import {
  Box,
  Button,
  Card,
  CardContent,
  Hidden,
  Typography,
} from "@material-ui/core";
import { makeStyles, useTheme, withTheme } from "@material-ui/core/styles";
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import "react-multi-carousel/lib/styles.css";
import Footer from "../components/Footer/Footer";
// Components
import Header from "../components/Header/Header";

export async function getStaticProps(context) {
  return {
    props: {}, // will be passed to the page component as props
  };
}

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    background: "#f5f5f5",
  },
  paper: {},
  title: {
    padding: "24px 16px",
  },
  main_image: {
    width: "100%",
    height: "245px",
    position: "relative",
    padding: "0",
  },
  main_image_phone: {
    width: "90%",
    height: "300px",
    position: "relative",
    padding: "0",
    marginLeft: "10%",
    display: "flex",
  },
  about_container: {
    padding: "1rem 2rem",
    // width: '100%',
    display: "flex",
    justifyContent: "flex-start",
    "& > div:first-child": {
      width: "25px",
      height: "25px",
    },
  },
  about_text: {
    fontFamily: "Quicksand",
    color: "#2a434e",
    fontSize: "14px",
    // textAlign: 'justify',
    padding: "18px",
  },
  primary: {
    color: theme.palette.primary.main,
  },
  about_q: {
    color: "#2a434e",
    fontSize: "16px",
    fontFamily: "Quicksand",
  },
  card_s: {
    height: "195px",
    width: "90%",
    margin: "3rem auto",
    borderRadius: "0 0 14px 14px",
  },
  card_media: {
    position: "relative",
    height: "144px",
  },
  card_content: {
    height: "51px",
    display: "flex",
    justifyContent: "center",
  },
  card_content_text: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  carousel: {
    marginTop: "36px",
  },
  card_item: {
    width: "158px",
    margin: "0",
    // padding: '0 20px'

    borderRadius: "0 0 11px 11px",
  },
  carousel_item: {
    height: "245px",
    width: "158px !important",
    padding: "0",
    marginLeft: "12px",
  },
  card_item_media: {
    height: "151px",
    position: "relative",
  },
  card_item_text: {
    height: "85px",
    display: "grid",
    gridTemplateRows: "1fr 1fr 1fr 2fr",
    padding: "9px",
  },
  card_item_label: {
    fontSize: "9px",
  },
  card_item_label_s: {
    fontSize: "8px",
    padding: "3px 0",
  },
  card_item_price: {
    fontSize: "11px",
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  footer: {
    height: "136px",
    background: "blue",
    marginTop: "36px",
  },
  list: {
    width: "100%",
    padding: "1rem 2rem",
    display: "grid",
    gridTemplateColumns: "2fr 10fr",
    gridTemplateRows: "repeat(3,1fr)",
    gridGap: "0",
  },
  item: {
    width: "33px",
    height: "33px",
    background: theme.palette.primary.main,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    fontSize: "1rem",
    boxShadow: "2px 2px 4px rgba(6,6,6,0.5)",
    alignSelf: "center",
  },
  item_label: {
    fontSize: "16px",
    color: "#2a434e",
    fontFamily: "Quicksand",
    alignSelf: "center",
  },
  sale_button: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "0 auto",
    "& > button": {
      width: "80%",
      margin: "2rem auto",
    },
  },
  span_text: {
    fontWeight: "bold",
    marginLeft: "5px",
  },

  img_full: {
    width: "100%",
    minHeight: "550px",
    position: "relative",
  },
  img_full2: {
    width: "100%",
    minHeight: "250px",
    display: "flex",
    justifyContent: "flex-start",
    margin: "3rem 0",
  },
  list2: {
    display: "grid",
    gridTemplateColumns: "100%",
    gridTemplateRows: "repeat(3, 1fr)",
    gridGap: "0.5rem",
    padding: "1rem 2rem 2rem 2rem",
  },
  list2_title: {
    fontSize: "22px",
  },
  list2_body: {
    fontSize: "16px",
  },
  icon_cont: {
    width: "45px",
    height: "50px",
  },
  text_primary: {
    color: theme.palette.primary.main,
  },
  desktop_title: {
    background: "white",
    padding: "2rem 5%",
    fontWeight: 700,
    "& > h4": {
      fontWeight: "bold",
    },
  },
  desktop_list: {
    width: "100%",
    display: "grid",
    padding: "2rem 10%",
    gridGap: "3rem 0",
    gridTemplateRows: "1fr",
    gridTemplateColumns: "1fr 1fr 1fr",
    minHeight: "250px",
    gridGap: "3rem",
  },
  list_item: {
    display: "grid",
    gridTemplateRows: "1fr",
    gridTemplateColumns: "25% 75%",
    margin: "3rem 0",
    "& > div": {
      alignSelf: "start",
    },
  },
  full_container: {
    width: "100%",
    position: "relative",
    height: "350px",
    [theme.breakpoints.up("lg")]: {
      minHeight: "400px",
      margin: "5% auto",
      "& img": {
        objectFit: "fill !important",
      },
    },
  },
  offer_container: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "auto",
    margin: "2rem 4rem",
  },
  right_container: {
    position: "relative",
    height: "480px",
    width: "50%",
    [theme.breakpoints.up("lg")]: {
      minHeight: "450px",
      margin: "5% auto",
      "& img": {
        objectFit: "fill !important",
      },
    },
  },
}));

function Sale(props) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div className={classes.root}>
      <Head>
        <title>Motofácil</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Header></Header>
      {/* Desktop */}
      <Hidden smDown>
        <Box
          width="100%"
          display="flex"
          justifyContent="flex-start"
          className={classes.desktop_title}
        >
          <Typography variant="h5" color="primary">
            Vender tu moto es así de fácil
          </Typography>
        </Box>
        <Box className={classes.desktop_list}>
          <Box className={classes.list_item}>
            <Box className={classes.item}>1</Box>
            <Box className={classes.item_label}>
              Completa los datos generales de tu moto y cuéntanos las
              condiciones en las que se encuentra.
            </Box>
          </Box>
          <Box className={classes.list_item}>
            <Box className={classes.item}>2</Box>
            <Box className={classes.item_label}>
              Elige la oferta que más te convenga.
            </Box>
          </Box>
          <Box className={classes.list_item}>
            <Box className={classes.item}>3</Box>
            <Box className={classes.item_label}>
              Presenta tu moto a una inspección en la hora y el lugar que
              prefieras con uno de nuestros agentes moto fácil y concluye la
              venta.
            </Box>
          </Box>
        </Box>
        <Box
          width="30%"
          margin={"2rem auto"}
          display="flex"
          justifyContent="center"
        >
          <Link href="/vende-tu-moto/contacto">
            <Button variant="contained" color="primary">
              obtener una oferta por mi moto
            </Button>
          </Link>
        </Box>
        <Box my={5} className={classes.full_container}>
          <Image
            src="/images/static/vende-tu-moto-desktop/img-2-x.webp"
            layout="fill"
            objectFit="contain"
          />
        </Box>
        <Box my={10} width="100%" display="flex" justifyContent="space-between">
          <Box width="50%" pl={5}>
            <Box mx={4} my={2}>
              <Typography variant="h6">
                Obtén en minutos una oferta que
                <Typography
                  variant="h6"
                  component="span"
                  color="primary"
                  className={classes.span_text}
                >
                  no podrás rechazar
                </Typography>
              </Typography>
            </Box>
            <Box my={4}>
              <Box className={classes.about_container}>
                <Image
                  src="/images/static/atomo-icon-medium-dark-check-on@3x.webp"
                  width={25}
                  height={25}
                ></Image>
                <Box ml={2}>
                  <Typography>Completamente seguro</Typography>
                </Box>
              </Box>
              <Box className={classes.about_container}>
                <Image
                  src="/images/static/atomo-icon-medium-dark-check-on@3x.webp"
                  width={25}
                  height={25}
                ></Image>
                <Box ml={2}>
                  <Typography>
                    Servicio de inspección y avalúo sin costo
                  </Typography>
                </Box>
              </Box>
              <Box className={classes.about_container}>
                <Image
                  src="/images/static/atomo-icon-medium-dark-check-on@3x.webp"
                  width={25}
                  height={25}
                  objectFit="contain"
                ></Image>
                <Box ml={2}>
                  <Typography>Pagamos de contado</Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className={classes.right_container}>
            <Image
              src="/images/static/vende-tu-moto-desktop/phone.webp"
              layout="fill"
              objectFit="contain"
            />
          </Box>
        </Box>

        <Box className={classes.offer_container}>
          <Box component="div" className={classes.list2}>
            <Box className={classes.icon_cont}>
              <Image
                src="/images/static/home/icon1.webp"
                width="45"
                height="50"
              />
            </Box>
            <Box className={classes.list2_title}>
              El proceso de compra es{" "}
              <span className={classes.text_primary}>completamente seguro</span>
            </Box>
            <Box className={classes.list2_body}>
              Sólo cuéntanos el estado general de tu moto, no te solicitaremos
              ningún tipo de pago
            </Box>
          </Box>
          <Box component="div" className={classes.list2}>
            <Box className={classes.icon_cont}>
              <Image
                src="/images/static/home/icon2.webp"
                width="35"
                height="50"
              />
            </Box>
            <Box className={classes.list2_title}>
              Vende sin intermediarios y con{" "}
              <span className={classes.text_primary}>garantía moto fácil</span>{" "}
            </Box>
            <Box className={classes.list2_body}>
              Deja de enseñar tu moto a desconocidos y obtén un precio justo
            </Box>
          </Box>
        </Box>
      </Hidden>

      {/* Mobile */}
      <Hidden mdUp>
        <Card>
          <CardContent className={classes.title}>
            <Typography variant="h6" color="primary">
              Vender tu moto es así de fácil
            </Typography>
          </CardContent>
        </Card>

        <Box className={classes.list}>
          <Box className={classes.item}>1</Box>
          <Box className={classes.item_label}>
            Completa los datos generales de tu moto y cuéntanos las condiciones
            en las que se encuentra.
          </Box>
          <Box className={classes.item}>2</Box>
          <Box className={classes.item_label}>
            Elige la oferta que más te convenga.
          </Box>
          <Box className={classes.item}>3</Box>
          <Box className={classes.item_label}>
            Presenta tu moto a una inspección en la hora y el lugar que
            prefieras con uno de nuestros agentes moto fácil y concluye la
            venta.
          </Box>
        </Box>
        <Box className={classes.sale_button}>
          <Link href="/vende-tu-moto/contacto">
            <Button variant="contained" color="primary">
              obtener una oferta por mi moto
            </Button>
          </Link>
        </Box>
        <Box component="div" className={classes.main_image}>
          <Image
            flexGrow={1}
            component="img"
            src="/images/static/img-2-x_2021-03-23/img-2-x.webp"
            layout="fill"
            objectFit="cover"
          />
        </Box>
        <Box mx={4} my={2}>
          <Typography variant="h6">
            Obtén en minutos una oferta que
            <Typography
              variant="h6"
              component="span"
              color="primary"
              className={classes.span_text}
            >
              no podrás rechazar
            </Typography>
          </Typography>
        </Box>
        <Box component="div" className={classes.main_image_phone}>
          <Image
            flexGrow={1}
            component="img"
            src="/images/static/vende-tu-moto-desktop/phone.webp"
            layout="fill"
            objectFit="fill"
          />
        </Box>
        <Box my={4}>
          <Box className={classes.about_container}>
            <Image
              src="/images/static/atomo-icon-medium-dark-check-on@3x.webp"
              width={25}
              height={25}
            ></Image>
            <Box ml={2}>
              <Typography>Completamente seguro</Typography>
            </Box>
          </Box>
          <Box className={classes.about_container}>
            <Image
              src="/images/static/atomo-icon-medium-dark-check-on@3x.webp"
              width={25}
              height={25}
            ></Image>
            <Box ml={2}>
              <Typography>Servicio de inspección y avalúo sin costo</Typography>
            </Box>
          </Box>
          <Box className={classes.about_container}>
            <Image
              src="/images/static/atomo-icon-medium-dark-check-on@3x.webp"
              width={25}
              height={25}
              objectFit="contain"
            ></Image>
            <Box ml={2}>
              <Typography>Pagamos de contado</Typography>
            </Box>
          </Box>
        </Box>
        <Box>
          <Box component="div" className={classes.list2}>
            <Box className={classes.icon_cont}>
              <Image
                src="/images/static/home/icon1.webp"
                width="45"
                height="50"
              />
            </Box>
            <Box className={classes.list2_title}>
              El proceso de compra es{" "}
              <span className={classes.text_primary}>completamente seguro</span>
            </Box>
            <Box className={classes.list2_body}>
              Sólo cuéntanos el estado general de tu moto, no te solicitaremos
              ningún tipo de pago
            </Box>
          </Box>
          <Box component="div" className={classes.list2}>
            <Box className={classes.icon_cont}>
              <Image
                src="/images/static/home/icon2.webp"
                width="35"
                height="50"
              />
            </Box>
            <Box className={classes.list2_title}>
              Vende sin intermediarios y con{" "}
              <span className={classes.text_primary}>garantía moto fácil</span>{" "}
            </Box>
            <Box className={classes.list2_body}>
              Deja de enseñar tu moto a desconocidos y obtén un precio justo
            </Box>
          </Box>
        </Box>
      </Hidden>

      <Footer></Footer>
    </div>
  );
}

export default withTheme(Sale);
